import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00ad10a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "screen-wrapper" }

import { computed, ref, toRaw, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { useAppStore } from '@/popup/store/AppStore'
import TransactionDetails from '@/popup/components/Transaction/TransactionDetails.vue'
import {
  Transaction,
  TransactionChangeMessage,
  TransactionIntermediateData,
} from '@/shared/models/Transaction'
import { assertNotUndefined } from '@/shared/validators'
import { requestModification } from '@/shared/apis/transactionChanges'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { InternalMethods } from '@/shared/apis/messages'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityDetail',
  setup(__props) {

const appStore = useAppStore()
const route = useRoute()
const router = useRouter()

const updatedTransaction = ref<Transaction | undefined>()

const currentTransaction = computed<Transaction | undefined>(() => {
  const transaction = appStore.transactions.find(
    tx => tx.requestId.toString() === route.params['txId']
  )
  if (!transaction) {
    return
  }

  if (transaction.gasPrice && transaction.gasUsed) {
    transaction.transactionFee = (
      transaction.gasUsed * Number.parseFloat(transaction.gasPrice)
    ).toString()
  }
  if (transaction.gasUsed && transaction.gasLimit) {
    transaction.gasUsedPercent =
      Math.round(
        ((100 * transaction.gasUsed) / Number.parseInt(transaction.gasLimit) +
          Number.EPSILON) *
          100
      ) / 100
  }
  return transaction
})

if (!currentTransaction.value) {
  router.back()
}

watch(
  () => currentTransaction.value,
  () => {
    if (!updatedTransaction.value || !currentTransaction.value) {
      return
    }
    if (updatedTransaction.value.status !== currentTransaction.value.status) {
      updatedTransaction.value.status = currentTransaction.value.status
    }
  }
)

/**
 * Convert raw transaction data to viewable transaction data
 *
 * @param transactionData raw transaction data from background
 */
const displayTransaction = (transactionData: TransactionIntermediateData) => {
  if (currentTransaction.value) {
    currentTransaction.value.to = transactionData.to
  }
}

/**
 * Request a modification of the transaction data. In some cases we need to re-validate
 * the transaction data inside of the background. requestModification will return true in those
 * cases
 *
 * @param key - the property to modify
 * @param value - the value to set the property to
 */
const onModifyTransaction = async (
  message?: TransactionChangeMessage,
  forceRecalculate = false
) => {
  assertNotUndefined(currentTransaction.value)
  if (message?.key === 'to') {
    updatedTransaction.value = {
      ...currentTransaction.value,
      to: message.value,
    }
  } else if (
    (message &&
      requestModification(
        currentTransaction.value,
        message.key,
        message.value
      )) ||
    forceRecalculate
  ) {
    const transactionData = await useGlobals().sendMessage({
      method: InternalMethods.RECALCULATE_TRANSACTION_DATA,
      payload: {
        requestId: currentTransaction.value?.requestId,
        options: toRaw(currentTransaction.value?.options || []),
      },
    })

    displayTransaction(transactionData)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TransactionDetails, {
      transaction: updatedTransaction.value || currentTransaction.value,
      onOnTransactionChange: onModifyTransaction
    }, null, 8 /* PROPS */, ["transaction"])
  ]))
}
}

})